import React, { useEffect, useState } from "react";
import { Form, Button, Col, Row, InputGroup, Alert } from "react-bootstrap";
import styles from "./SignUp.module.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { MdArrowBack } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import House from "../../assets/housee.svg";
import Swal from "sweetalert2";
import { BASE_URL } from "../../Components/API/Api";
import Oglogo from "../../assets/eprocurement.png";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [alert, setAlert] = useState({
    show: false,
    type: "",
    message: "",
  });

  // ✅ GET TOKEN FROM URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tokenFromUrl = searchParams.get("token");
    setToken(tokenFromUrl);
  }, [location.search]);

  // ✅ PASSWORD VALIDATION
  const getPasswordError = () => {
    if (!password) return "";

    if (password.length < 8) return "Minimum of 8 characters required";
    if (!/[A-Z]/.test(password)) return "At least one uppercase letter required";
    if (!/[a-z]/.test(password)) return "At least one lowercase letter required";
    if (!/[0-9]/.test(password)) return "At least one number required";
    if (!/[!@#$%^&*]/.test(password)) return "At least one special character required";

    return "";
  };

  const passwordError = getPasswordError();

  const confirmError =
    confirmPassword && password !== confirmPassword
      ? "Passwords do not match"
      : "";

  const hasError = passwordError || confirmError;

  // ✅ RESET PASSWORD FUNCTION
  const handleResetPassword = async () => {
    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/reset_password`, {
        password: password,
        password_confirmation: confirmPassword,
        token: token,
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message || "Password reset successful",
      });

      navigate("/login");
    } catch (error) {
      let errorMessage = "Something went wrong";

      if (error.response?.data?.message) {
        const msg = error.response.data.message;

        if (typeof msg === "string") errorMessage = msg;
        else if (typeof msg === "object")
          errorMessage = Object.values(msg).flat().join(", ");
      }

      setAlert({
        show: true,
        type: "danger",
        message: errorMessage,
      });

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };


  
  return (
    <div className={styles.wrapper}>
      {/* LEFT SIDE */}
      <div className={styles.left}>
        <div className={styles.logo} onClick={handleBack}>
        <img src={Oglogo} alt="logo" className={styles.imglogo} />
        </div>

        <div className={styles.leftContent}>
          <h1 className={styles.welcome}>Procurement</h1>
          <h1 className={styles.title}>
            <span className={styles.ogtxt}>Simplified &</span>
            <span className={styles.txtclor}> Transparent</span>
          </h1>

          <h4 className={styles.description}>
            Register your company to access Ogun State government procurement opportunities through a secure and transparent platform
          </h4>      
          <ul className={styles.listItems}>
  <li>CAC-verified suppliers only</li>
  <li>Secure bidding and contract awards</li>
  <li>Access to opportunities across Nigeria</li>
</ul>
 <img src={House} className={styles.houseIcon} />
        </div>

        {/* <p className={styles.footer}>
          © {getCurrentYear()} TABBACCI, LICENSED TO OGUN STATE INTERNAL REVENUE SERVICE
        </p> */}
      </div>

      {/* RIGHT SIDE */}
      <div className={styles.right}>
        <div className={styles.topCont}>
        <div className={styles.backIcons} onClick={handleBack}>
        <MdArrowBack style={{fontSize: 20, color: '#059669'}}/>
        <p className={styles.backtxt} >Go Back</p>
        </div>
        {/* <p className={styles.alreadyTxt}>Already have an account? <span onClick={handleLogin} className={styles.loginLink}>Login</span></p> */}
        </div>
{/* <div className={styles.stepperCont}>
   <img src={currentStep === 0 ? Stepper : Stepper2} className={styles.stpperIcon} />
</div> */}
        <div className={styles.formCard}>
          <div className={styles.welcometxt}>
                <h1>Reset Password</h1>
                <p>Don't worry – we'll help you reset your password. Just enter your new password.</p>
          </div>
      {alert.show && (
            <Alert
              variant={alert.type}
              onClose={() => setAlert({ ...alert, show: false })}
              dismissible
            >
              {alert.message}
            </Alert>
          )}
      
  
 
  <Col md={12} >
    <Form.Group>
      <Form.Label className={styles.txtfom}>New Password</Form.Label>

      <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  className={styles.txtfield}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  isInvalid={!!passwordError}
                />

                <InputGroup.Text
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: "pointer", background: "transparent" }}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </InputGroup.Text>
              </InputGroup>

              {passwordError && (
                <div style={{ color: "red", fontSize: 12 }}>
                  {passwordError}
                </div>
              )}
    </Form.Group>
  </Col>



  {/* LAST FIELD — FULL WIDTH */}
  <Row className="mb-4" style={{ marginTop: 20 }}>
    <Col md={12}>
      <Form.Group>
        <Form.Label className={styles.txtfom}>
          Confirm New Password
        </Form.Label>

        <Form.Control
                  type="password"
                  placeholder="Confirm password"
                  className={styles.txtfield}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  isInvalid={!!confirmError}
                />

          {confirmError && (
            <div style={{ color: "red", fontSize: 13, marginTop: 4 }}>
              {confirmError}
            </div>
          )}

      </Form.Group>
    </Col>
  </Row>

   <Button
            className={styles.signInBtn}
            onClick={handleResetPassword}
            disabled={
              hasError || !password || !confirmPassword || loading
            }
          >
            {loading ? "Resetting..." : "Reset Password"}
          </Button>






        

          

        
        </div>

      </div>
    </div>
  );
};

export default ResetPassword;
